import React, { useState } from 'react';
import './BookingModal.css'; // We'll create this CSS next

const BookingModal = ({ doctor, onClose, onBook }) => {
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [patientName, setPatientName] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onBook({ doctor, date, time, patientName });
    };

    if (!doctor) return null;

    return (
        <div className="booking-modal-overlay">
            <div className="booking-modal-content">
                <h2>Book Appointment with {doctor.name}</h2>
                <p className="doctor-specialty">{doctor.specialty}</p>
                <p className="doctor-location">{doctor.location}</p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Patient Name</label>
                        <input
                            type="text"
                            required
                            value={patientName}
                            onChange={(e) => setPatientName(e.target.value)}
                            placeholder="Enter patient name"
                        />
                    </div>

                    <div className="form-group">
                        <label>Date</label>
                        <input
                            type="date"
                            required
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </div>

                    <div className="form-group">
                        <label>Time</label>
                        <input
                            type="time"
                            required
                            value={time}
                            onChange={(e) => setTime(e.target.value)}
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
                        <button type="submit" className="confirm-btn">Confirm Booking</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BookingModal;
